enum Types {
    CHECK = 'check',
    DATE = 'date',
    FILE = 'file',
    MULTIPLE = 'multiple',
    NUMBER = 'number',
    SELECT = 'select',
    SUGGESTIONS = 'suggestions',
    TEXT = 'text',
    TEXTAREA = 'textarea',
    RADIO = 'radio',
}

export default Types
